import { isObject } from "@pineapplelab/util";
import { FBase } from "./FBase";
import { Timestamp } from "firebase/firestore";
import { serverTimestamp } from "firebase/firestore";
import { DocumentReference } from "@angular/fire/compat/firestore";
import { MediaLibraryFile } from "../enums/mediaLibraryFileType.enum";
import { EnrollmentAnswer } from "./enrollmentAnswer";

/**
 * A finished quiz attempt, archived when a retake is granted.
 *
 * `totalQuestions` is stored rather than recomputed because an alternate may have a different
 * number of questions than the original, and an author editing a quiz later would otherwise
 * retroactively change what a historical score appears to mean.
 */
export interface QuizAttemptHistory {
	attempt: number;
	quizScore: number;
	totalQuestions: number;
	quizAnswers: EnrollmentAnswer[];
	approvedQuiz: boolean;
	completedAt: Timestamp;
}

export class ChapterEnrollment extends FBase {

	name: string = null;
	completedAt: Timestamp = Timestamp.now();
	quizScore: number = null;
	notes: DocumentReference = null;
	approvedQuiz: boolean = false;
	quizAnswers: EnrollmentAnswer[] = [];
	index: number = null;
	hasQuiz: boolean = null;
	hasVideo: boolean = null;
	isFavorite: boolean = false;
	// TODO: change this prop name for "isVideoCompleted" or something similar, change should be made in backend too (enrollment)
	isVideoWatched: boolean = false;
	pdfDownloaded: boolean = false;
	lockedChapter: boolean = false;
	videoCurrentTime: number = null;
	allowFastForward: boolean = true;
	fileType: MediaLibraryFile = null;
	// Which quiz version is active. 0 = the chapter's own inline quiz, so existing enrollments keep
	// their original behaviour with no migration.
	quizAttempt: number = 0;
	// Set by the external client's grant endpoint; cleared once this attempt is submitted.
	retakeGranted: boolean = false;
	quizAttemptHistory: QuizAttemptHistory[] = [];

	__name: string = null;
    __videoDuration: number = null;

	constructor(json?: { [key: string]: any }) {
		super();
		if (isObject(json)) {
			this.fromJson(json);
		}
	}
}
export namespace ChapterEnrollment {

	export const PATH = 'chapterEnrollments';

}
